<template>
  <div>
    <div class="section-hero-subpage bg-color-primary">
      <video autoplay loop muted playsinline>
        <source src="/frontend/assets/videos/video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div class="container">
        <div class="paragraph--normal text-uppercase text-color-quinary mb-2">
          <span class="notranslate" translate="no">SELECTED</span> CARS
        </div>
        <h1
          class="heading--0 text-uppercase text-color-quinary border-bottom-quinary padding-bottom-2 margin-bottom-3-lg"
        >
          <span class="fw-light"
            >DREAM CAR IS<br />
            JUST</span
          >
          CONVERSATION<br />
          <span class="fw-light">AWAY</span>
        </h1>
        <div class="row">
          <div class="col-lg-7">
            <p class="paragraph--xlarge text-color-senary mb-0">
              We utilize our global network and industry expertise to source the
              most exclusive and rare luxury vehicles on your behalf, regardless
              of availability or waiting lists.
            </p>
          </div>
        </div>
        <div class="d-lg-none mt-4">
          <a
            href="#"
            class="btn btn--normal btn--icon--100 btn--icon--100--right btn--primary text-uppercase w-100"
          >
            <Icon icon="material-symbols:expand-circle-down-rounded" class="iconify" /> TELL US
            MORE
          </a>
        </div>
      </div>
    </div>

    <div class="section-normal bg-color-octrary cor-form">
      <div class="container">
        <div class="row">
          <div
            class="col-lg-5 border-right-quinary padding-right-7-lg mb-lg-0 mb-5"
          >
            <h2 class="heading--5 text-uppercase text-color-quinary mb-4">
              WHAT car YOU'RE LOOKING FOR
            </h2>
            <p
              class="paragraph--xlarge text-color-quinary margin-bottom-4-lg margin-bottom-5"
            >
              Whether it's a specific model, a rare edition, or simply a vision
              of your perfect vehicle, our team of experts will leverage our
              exclusive network to find exactly what you desire.
            </p>
            <div
              class="padding-bottom-3-lg margin-bottom-3-lg padding-bottom-2 margin-bottom-2 border-bottom-quinary text-lg-start text-center"
            >
              <div class="heading--2 text-color-quinary">98%</div>
              <div class="paragraph--xlarge text-color-senary">
                Procurement Success Rate
              </div>
            </div>
            <div
              class="padding-bottom-3-lg margin-bottom-3-lg padding-bottom-2 margin-bottom-2 border-bottom-quinary text-lg-start text-center"
            >
              <div class="heading--2 text-color-quinary">92</div>
              <div class="paragraph--xlarge text-color-senary">
                Dealerships Network
              </div>
            </div>
            <div class="text-lg-start text-center">
              <div class="heading--2 text-color-quinary">1-3 months</div>
              <div class="paragraph--xlarge text-color-senary">
                Estimated time
              </div>
            </div>
            
          </div>
          <div class="col-lg-7 padding-left-7-lg">
            <form @submit.prevent="submitRequest">
              <!-- Your Name -->
              <div class="margin-bottom-2">
                <label for="name" class="form-label">Your Name</label>
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  v-model="form.name"
                  placeholder="Enter your name"
                  required
                  :class="{'is-invalid': errors.name}"
                />
                <div class="invalid-feedback" v-if="errors.name">
                  {{ errors.name }}
                </div>
              </div>

              <!-- Your Email -->
              <div class="margin-bottom-2">
                <label for="email" class="form-label">Your Email</label>
                <input
                  type="email"
                  class="form-control"
                  id="email"
                  v-model="form.email"
                  placeholder="Enter your email"
                  required
                  :class="{'is-invalid': errors.email}"
                />
                <div class="invalid-feedback" v-if="errors.email">
                  {{ errors.email }}
                </div>
              </div>
                
                <div class="mb-3">
                  <label for="phone" class="form-label text-color-quinary">Your Phone</label>
                  <input 
                    type="tel" 
                    class="form-control" 
                    id="phone" 
                    v-model="form.phone"
                    placeholder="+421 XXX XXX XXX"
                    required
                    :class="{'is-invalid': errors.phone}"
                  >
                  <div class="invalid-feedback" v-if="errors.phone">
                    {{ errors.phone }}
                  </div>
                </div>
                
              <!-- Condition -->
              <div class="margin-bottom-2">
                <label for="condition" class="form-label">Condition</label>
                <select class="form-select" id="condition" v-model="form.condition" required :class="{'is-invalid': errors.condition}">
                  <option value="" disabled>Select car condition</option>
                  <option value="New">New</option>
                  <option value="Used">Used</option>
                </select>
                <div class="invalid-feedback" v-if="errors.condition">
                  {{ errors.condition }}
                </div>
              </div>
                
                <div class="margin-bottom-2">
                  <label for="vehicleDetails" class="form-label">Vehicle Details</label>
                  <input 
                    type="text" 
                    class="form-control" 
                    id="vehicleDetails" 
                    v-model="form.vehicle_details"
                    placeholder="E.g., BMW M4, Porsche 911, etc."
                    :class="{'is-invalid': errors.vehicle_details}"
                  >
                  <div class="invalid-feedback" v-if="errors.vehicle_details">
                    {{ errors.vehicle_details }}
                  </div>
                </div>
                
                <div class="margin-bottom-2">
                  <label for="description" class="form-label">Additional Requirements</label>
                  <textarea 
                    class="form-control" 
                    id="description" 
                    rows="4"
                    v-model="form.description"
                    placeholder="Please provide any specific details about the vehicle you're looking for (color, options, etc.)"
                    :class="{'is-invalid': errors.description}"
                  ></textarea>
                  <div class="invalid-feedback" v-if="errors.description">
                    {{ errors.description }}
                  </div>
                </div>
                
                <div class="alert alert-danger mt-3" v-if="errors.general">
                  {{ errors.general }}
                </div>
                
                <button
                  type="submit"
                  class="btn btn--normal btn--icon--100 btn--secondary px-5 justify-content-center w-100"
                  :disabled="loading"
                >
                  <Icon icon="heroicons:envelope-solid" class="iconify" />
                  SUBMIT INQUIRY FOR VEHICLE
                  <span v-if="loading" class="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>
                </button>

                <div class="alert alert-success mt-3" v-if="successMessage">
                  {{ successMessage }}
                </div>

                <div class="alert alert-danger mt-3" v-if="errors.general">
                  {{ errors.general }}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section-normal bg-color-quaternary">
      <div class="container">
        <h2 class="heading--4 fw-light text-color-quinary text-uppercase">
          PASSION IN DETAILS AND LUXURY SEGMENT
        </h2>
        <p
          class="paragraph--xlarge text-color-quinary border-bottom-quinary padding-bottom-3-lg padding-bottom-2 margin-bottom-5-lg margin-bottom-3"
        >
          A seamless expierinece from inquiry to delivery
        </p>

        <div class="row">
          <div class="col-xl-3 col-lg-4 col-md-6 mb-xl-0 mb-4">
            <div class="block-item h-100">
              <div class="heading--5 text-color-senary lh-1 margin-bottom-2">
                01
              </div>
              <div class="paragraph--xxxlarge text-color-quinary lh-1 mb-3">
                Personalized<br />
                Consultation
              </div>
              <p class="paragraph--normal text-color-senary mb-0">
                Our luxury vehicle specialists will discuss your requirements,
                preferences, and specifications in detail.
              </p>
            </div>
          </div>
          <div class="col-xl-3 col-lg-4 col-md-6 mb-xl-0 mb-4">
            <div class="block-item h-100">
              <div class="heading--5 text-color-senary lh-1 margin-bottom-2">
                02
              </div>
              <div class="paragraph--xxxlarge text-color-quinary lh-1 mb-3">
                Global <br />Search
              </div>
              <p class="paragraph--normal text-color-senary mb-0">
                We activate our network of dealers, manufacturers, and private
                collectors worldwide to locate your desired vehicle.
              </p>
            </div>
          </div>
          <div class="col-xl-3 col-lg-4 col-md-6 mb-xl-0 mb-4">
            <div class="block-item h-100">
              <div class="heading--5 text-color-senary lh-1 margin-bottom-2">
                03
              </div>
              <div class="paragraph--xxxlarge text-color-quinary lh-1 mb-3">
                Proposal &<br />
                Acquisition
              </div>
              <p class="paragraph--normal text-color-senary mb-0">
                We present you with options, handle negotiations, and manage all
                paperwork and logistics on your behalf.
              </p>
            </div>
          </div>
          <div class="col-xl-3 col-lg-4 col-md-6 mb-xl-0 mb-4">
            <div class="block-item h-100">
              <div class="heading--5 text-color-senary lh-1 margin-bottom-2">
                04
              </div>
              <div class="paragraph--xxxlarge text-color-quinary lh-1 mb-3">
                Delivery<br />
                Experience
              </div>
              <p class="paragraph--normal text-color-senary mb-0">
                Your vehicle is delivered to your preferred location with a
                personalized handover experience.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <AppMarquee />
  
</template>

<script>
import AppMarquee from '../components/AppMarquee.vue';
import axios from 'axios';
import { Icon } from '@iconify/vue';

export default {
  components: {
    AppMarquee,
    Icon
  },
  data() {
    return {
      form: {
        name: '',
        email: '',
        phone: '',
        condition: 'New',
        vehicle_details: '',
        description: ''
      },
      errors: {},
      loading: false,
      successMessage: ''
    };
  },
  mounted() {
    import('../seo.js').then(({ setPageSeo }) => setPageSeo({
      title: 'Car on Request | Find Any Car from Europe | Selected Cars',
      description: 'Tell us what car you want — we find it in Europe. Any brand, any model, any specification. BMW, Mercedes, Porsche, Audi, Lamborghini, Ferrari, Land Rover. Factory orders and rare configs. Free quote within 24 hours from 92 European dealers.',
      keywords: 'car on request, find car europe, order car from europe, custom car order, factory order car, source specific car, find BMW europe, find Mercedes europe, find Porsche, car search service, bespoke car sourcing, car finder europe',
      breadcrumbs: [
        { name: 'Home', url: '/' },
        { name: 'Car on Request', url: '/car-on-request' }
      ]
    }));
  },
  methods: {
    validateForm() {
      this.errors = {};
      
      if (!this.form.name) {
        this.errors.name = 'Name is required';
      }
      
      if (!this.form.email) {
        this.errors.email = 'Email is required';
      } else if (!/^\S+@\S+\.\S+$/.test(this.form.email)) {
        this.errors.email = 'Please enter a valid email address';
      }
      
      if (!this.form.phone) {
        this.errors.phone = 'Phone number is required';
      }
      
      if (!this.form.condition) {
        this.errors.condition = 'Please select a condition';
      }
      
      if (!this.form.vehicle_details) {
        this.errors.vehicle_details = 'Vehicle details are required';
      }
      
      if (!this.form.description) {
        this.errors.description = 'Please provide additional requirements';
      }
      
      return Object.keys(this.errors).length === 0;
    },
    
    async submitRequest() {
      if (!this.validateForm()) {
        return;
      }
      
      this.loading = true;
      this.successMessage = '';
      this.errors = {};
      
      try {
        // Set up CSRF token for the axios request
        const token = document.querySelector('meta[name="csrf-token"]');
        if (token) {
          axios.defaults.headers.common['X-CSRF-TOKEN'] = token.getAttribute('content');
        }
        
        // Configure axios with proper headers
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        
        console.log('Submitting vehicle request:', this.form);
        
        // Send the form data to the backend API
        const response = await axios.post('/api/vehicle-requests', this.form);
        
        console.log('Vehicle request submitted successfully:', response.data);
        
        // Show success message and reset form
        this.successMessage = 'Thank you for your request! Our team will contact you shortly to discuss your requirements.';
        this.form = {
          name: '',
          email: '',
          phone: '',
          condition: 'New',
          vehicle_details: '',
          description: ''
        };
        
        // Scroll to top to show success message
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } catch (error) {
        console.error('Error submitting request:', error);
        
        if (error.response && error.response.data && error.response.data.errors) {
          // Handle validation errors from the server
          const serverErrors = error.response.data.errors;
          for (const field in serverErrors) {
            this.errors[field] = serverErrors[field][0];
          }
        } else {
          this.errors.general = 'An error occurred while submitting your request. Please try again.';
        }
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.hero-section {
  padding-top: 80px; /* To account for the fixed header */
}

.benefit-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.05);
  padding: 1.5rem;
  border-radius: 4px;
}

.benefit-item--icon {
  font-size: 2rem;
  color: #fff;
}

.benefit-item--content h4 {
  font-size: 1.25rem;
  color: #fff;
  margin-bottom: 0.5rem;
}

.benefit-item--content p {
  color: #ccc;
  margin-bottom: 0;
}

.form-control {
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  padding: 0.75rem 1rem;
}

.form-control:focus {
  background-color: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
  color: #fff;
  box-shadow: none;
}

.form-control::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.form-check-input {
  background-color: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.3);
}

.form-check-input:checked {
  background-color: #fff;
  border-color: #fff;
}

.form-label {
  font-weight: 500;
}

.process-steps {
  position: relative;
}

.process-step {
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
  margin-bottom: 2rem;
  position: relative;
}

.process-step:last-child {
  margin-bottom: 0;
}

.process-step--number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #fff;
  color: #000;
  font-weight: 700;
  font-size: 1.25rem;
  flex-shrink: 0;
  position: relative;
  z-index: 2;
}

.process-step--content {
  padding-top: 0.5rem;
}

.process-step--content h4 {
  font-size: 1.25rem;
  color: #fff;
  margin-bottom: 0.5rem;
}

.process-step--content p {
  color: #ccc;
  margin-bottom: 0;
}

.process-steps::before {
  content: '';
  position: absolute;
  top: 0;
  left: 20px;
  width: 1px;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.2);
  z-index: 1;
}
</style>
